exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bottom-headers-wrapper{position:absolute;left:0;right:0;bottom:0;pointer-events:none}.BottomHeader{display:inline-block;width:100%;transition:transform .3s ease-in-out;pointer-events:auto}.BottomHeader.closed{transform:translateY(100%)}.BottomHeader.stroke{border-top:1px solid var(--gray-5)}", ""]);

// exports
